export default "__VITE_ASSET__CWwDHTiN__"